import React, { useEffect, useRef } from 'react';

// Limpa o HTML do editor: só formatação simples (negrito, itálico, listas, links).
// Tudo o mais (scripts, estilos, eventos, imagens) é descartado — o currículo do aluno
// é exibido para os admins, então nada executável pode passar.
const PERMITIDAS = new Set(['B', 'STRONG', 'I', 'EM', 'U', 'P', 'BR', 'UL', 'OL', 'LI', 'A', 'DIV', 'SPAN', 'H3', 'H4', 'BLOCKQUOTE']);

export function limparHtml(html) {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
  const limpa = (no) => {
    [...no.childNodes].forEach(filho => {
      if (filho.nodeType === 3) return; // texto
      if (filho.nodeType !== 1 || !PERMITIDAS.has(filho.tagName)) {
        if (filho.nodeType === 1 && !['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'IMG', 'SVG'].includes(filho.tagName)) {
          limpa(filho);
          filho.replaceWith(...filho.childNodes);
        } else {
          filho.remove();
        }
        return;
      }
      const href = filho.tagName === 'A' ? filho.getAttribute('href') : null;
      [...filho.attributes].forEach(a => filho.removeAttribute(a.name));
      if (filho.tagName === 'A') {
        if (href && /^(https?:|mailto:)/i.test(href.trim())) {
          filho.setAttribute('href', href.trim());
          filho.setAttribute('target', '_blank');
          filho.setAttribute('rel', 'noopener noreferrer');
        }
      }
      limpa(filho);
    });
  };
  const raiz = doc.body.firstChild;
  limpa(raiz);
  return raiz.innerHTML;
}

const BOTOES = [
  ['bold', 'B', { fontWeight: 800 }],
  ['italic', 'I', { fontStyle: 'italic' }],
  ['underline', 'U', { textDecoration: 'underline' }],
  ['insertUnorderedList', '• Lista'],
  ['insertOrderedList', '1. Lista'],
  ['link', '🔗 Link'],
  ['removeFormat', '✕ Limpar'],
];

// Editor simples (negrito, itálico, sublinhado, listas, link). value/onChange em HTML limpo.
export default function EditorRico({ value, onChange, placeholder = 'Digite algo...', limite = 5000 }) {
  const ref = useRef(null);
  // Só reescreve o conteúdo quando o valor muda "de fora" (não enquanto a pessoa digita,
  // senão o cursor pula para o começo)
  useEffect(() => {
    if (ref.current && document.activeElement !== ref.current && ref.current.innerHTML !== (value || '')) {
      ref.current.innerHTML = limparHtml(value || '');
    }
  }, [value]);

  const emitir = () => onChange?.(limparHtml(ref.current?.innerHTML || ''));
  const comando = (cmd) => {
    ref.current?.focus();
    if (cmd === 'link') {
      const url = window.prompt('Endereço do link (https://...)');
      if (url && /^https?:\/\//i.test(url)) document.execCommand('createLink', false, url);
    } else {
      document.execCommand(cmd, false, null);
    }
    emitir();
  };
  const caracteres = (ref.current?.innerText || '').length;

  return (
    <div className="inep-editor">
      <div className="inep-editor-bar">
        {BOTOES.map(([cmd, rotulo, estilo]) => (
          <button key={cmd} type="button" onMouseDown={e => { e.preventDefault(); comando(cmd); }} style={estilo}>{rotulo}</button>
        ))}
      </div>
      <div
        ref={ref}
        className="inep-editor-area"
        contentEditable
        suppressContentEditableWarning
        data-placeholder={placeholder}
        onInput={emitir}
        onBlur={emitir}
        onPaste={e => { e.preventDefault(); document.execCommand('insertText', false, e.clipboardData.getData('text/plain')); }}
      />
      <div className="inep-editor-foot">Caracteres: {caracteres}{limite ? ` / ${limite}` : ''}</div>
    </div>
  );
}
